module.exports = __webpack_public_path__ + "img/马云福.92f8c1fa.jpg";